import React from 'react';
import { AlertTriangle } from 'lucide-react';
import { useTranslation } from 'react-i18next';

export const ErrorFallback: React.FC = () => {
  const { t } = useTranslation('common');

  return (
    <div className="min-h-screen bg-primary-inverse flex flex-col items-center justify-center px-4">
      <div className="text-center space-y-8 max-w-2xl">
        {/* Flying Pigeon Animation */}
        <div className="relative h-32">
          <div className="absolute left-0 animate-fly-across">🐦</div>
          <div className="absolute left-1/4 animate-fly-across-delay-1">🐦</div>
          <div className="absolute left-1/2 animate-fly-across-delay-2">🐦</div>
        </div>

        {/* Error Icon */}
        <div className="flex justify-center">
          <AlertTriangle className="h-16 w-16 text-red-500 animate-pulse" />
        </div>

        {/* Message */}
        <div className="space-y-4">
          <h2 className="text-3xl font-bold text-secondary">{t('error.boundary.title')} 🚨</h2>
          <p className="text-xl text-[#3B5266]">{t('error.boundary.subtitle')} ☕</p>
        </div>

        {/* Bread Crumbs Trail */}
        <div className="flex justify-center space-x-2 text-2xl">🍞 🍞 🍞</div>

        {/* Action Button */}
        <div className="flex justify-center mt-8">
          <button
            onClick={() => window.location.reload()}
            className="px-6 py-3 bg-primary text-white rounded-full font-bold hover:bg-[#3B5266] transition-colors"
          >
            {t('error.boundary.reloadButton')}
          </button>
        </div>

        {/* Fun Footer */}
        <div className="mt-12 text-[#3B5266] text-sm">
          <p>💭 {t('error.boundary.footer1')}</p>
          <p className="mt-2">🕊️ {t('error.boundary.footer2')}</p>
        </div>
      </div>
    </div>
  );
};
